import CustomerVehicleFooterContainer from './CustomerVehicleFooterContainer';

export default CustomerVehicleFooterContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleFooter/index.js